import React, { useEffect } from 'react';
import Alert from "components/Common/Alert";

function SaveSiteSuccess({ 
  showAlert, 
  setShowAlert, 
  handleAddShow, 
  inputTextMain, 
  inputTextButton, 
  showCancelButton, 
  showCloseButton, 
  cancelButtonText, 
  handleConfirm, 
  handleClose,
}) {

  useEffect(() => {
    if (showAlert) {
      Alert({
        text: `${inputTextMain}`,
        icon: "success",
        showCancelButton: showCancelButton ?? true,
        showCloseButton: showCloseButton ?? false,
        cancel: showCloseButton ?? false,
        cancelButtonText: `${cancelButtonText ?? 'Cancel'}`,
        confirmButtonText: `${inputTextButton}`
      }).then((result) => {
        if (result.isConfirmed) {
          setShowAlert(false);
          handleAddShow();
          handleConfirm?.();
        } else {
          setShowAlert(false);
          handleClose?.()
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAlert])

  return (
    <>
    </>
  )
}

export default SaveSiteSuccess
